export function loadVideo() {
  const previews = document.querySelectorAll(".js-video-preview");

  previews.forEach((preview) => {
    preview.addEventListener("click", (e) => {
      if (preview.classList.contains("is-playing")) return;

      const videoSrc = preview.dataset.video;
      const poster = preview.dataset.poster;

      if (!videoSrc) return;

      preview.classList.add("is-playing");

      preview.innerHTML = `
        <video
          class="b-video-video"
          controls
          autoplay
          muted
          playsinline
          preload="metadata"
          poster="${poster}"
        >
          <source src="${videoSrc}">
        </video>
      `;
    });
  });
}
